import {Component, Input} from '@angular/core';
import {ImportMode} from "../../model/import-export-enum.model";
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-cart-import-user-manual',
    templateUrl: './cart-import-user-manual.component.html',
    imports: [TranslatePipe]
})
export class CartImportUserManualComponent {
  @Input() importMode: ImportMode;

  protected readonly ImportMode = ImportMode;
}
